import depo from './depo';
import axios from 'axios';
import { chunkHatasiMi, eskiPaketHatasiMi, yeniSurumUyarisiAc } from './yeniSurum';

// IZ-J (SaglayiciKonsolu/ISTATISTIK-VE-IZLEME-PLANI.md V9): panelde yakalanmamış JS hataları →
// POST SetIstemciHata. Kurallar:
// - imza = mesaj + ilk yığın satırı; aynı imza istemcide dakikada en fazla 1 kez (BE ayrıca şirket
//   başına 100/gün sınırlar, günde tek sistem çağrısı açar).
// - yalnız oturum açıkken (token var ve süresi dolmamış) — girişsiz sayfalar ve süresi dolmuş
//   oturum gönderilmez (refresh/çıkış akışını tetiklemesin).
// - chunk yükleme hatası (YS1, yeniSurum.js) hariç — o "yeni sürüm" uyarısıyla ele alınıyor.
// - kendi gönderim hatası asla yeniden raporlanmaz (sonsuz döngü koruması) ve sessizce yutulur.

const ARALIK_MS = 60 * 1000;
const OTURUM_TAVAN = 30; // bir sayfa yüklemesinde gönderilecek en fazla rapor (bozuk döngüye karşı)
const gonderici = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api.hepy.app/api/' : 'https://localhost:44386/api/',
  timeout: 10000,
  validateStatus: () => true,
});
const sonGonderim = new Map();
let gonderilen = 0;
let gonderiyor = false;

const YOKSAY = [
  /^ResizeObserver loop/,
  /^Script error\.?$/, // çapraz kökenli betik — içerik yok
  /^Network Error$/, // axios bağlantı hatası (baglanti.js ayrı ele alır)
  /^Request aborted$/,
  /^timeout of \d+ms exceeded$/,
];

function kirp(s, n) {
  s = s == null ? '' : String(s);
  return s.length > n ? s.slice(0, n) : s;
}

function oturumAcikMi() {
  const token = depo.oku('token');
  const bitis = parseInt(depo.oku('tokenExpiration'), 10);
  return !!token && !!bitis && Date.now() < bitis;
}

// Yığındaki ilk çerçeve satırı (Chrome "at f (url:1:2)", Firefox/Safari "f@url:1:2").
function ilkYiginSatiri(yigin) {
  const satirlar = String(yigin || '').split('\n').map((x) => x.trim()).filter(Boolean);
  const cerceve = satirlar.find((x) => /^at\s/.test(x) || /@\S+:\d+/.test(x));
  return cerceve || '';
}

// Uygulama paketinin karma adı (app.<hash>.js) — sürüm yerine geçer (build numarası yok).
function surum() {
  try {
    const s = Array.from(document.scripts || []).map((x) => x.src || '').find((x) => /\/js\/app\.[0-9a-f]+\.js/.test(x));
    const m = s && s.match(/\/js\/app\.([0-9a-f]+)\.js/);
    return m ? m[1] : (process.env.NODE_ENV === 'production' ? '' : 'dev');
  } catch (e) {
    return '';
  }
}

function hataBilgisi(hata, varsayilanMesaj) {
  if (hata instanceof Error || (hata && typeof hata === 'object' && (hata.message || hata.stack))) {
    const ad = hata.name && hata.name !== 'Error' ? hata.name + ': ' : '';
    return { mesaj: ad + (hata.message || varsayilanMesaj || ''), yigin: hata.stack || '' };
  }
  if (hata == null) return { mesaj: varsayilanMesaj || '', yigin: '' };
  let metin;
  try { metin = typeof hata === 'string' ? hata : JSON.stringify(hata); } catch (e) { metin = String(hata); }
  return { mesaj: metin, yigin: '' };
}

export function istemciHataBildir(hata, ekMesaj) {
  try {
    if (gonderiyor) return; // gönderim sırasında oluşan hata (kendi hatamız) raporlanmaz
    if (!hata && !ekMesaj) return;
    if (chunkHatasiMi(hata)) return;
    if (hata && hata.isAxiosError) return;
    if (!oturumAcikMi()) return;
    if (gonderilen >= OTURUM_TAVAN) return;

    const { mesaj, yigin } = hataBilgisi(hata, ekMesaj);
    const temizMesaj = kirp(mesaj, 500).trim();
    if (!temizMesaj || YOKSAY.some((r) => r.test(temizMesaj))) return;

    const imza = kirp(temizMesaj.split('\n')[0] + ' | ' + ilkYiginSatiri(yigin), 200);
    const simdi = Date.now();
    const onceki = sonGonderim.get(imza);
    if (onceki && simdi - onceki < ARALIK_MS) return;
    sonGonderim.set(imza, simdi);
    gonderilen++;

    const url = kirp((window.location && window.location.pathname) || '', 300); // query'siz
    gonderiyor = true;
    let p;
    try {
      // Servis() yerine ayrı axios örneği: global interceptor'lar (401 → refresh/çıkış, bağlantı
      // uyarısı, "kaydedilmemiş yazma" takibi) arka plan telemetrisi için tetiklenmesin.
      p = gonderici.post('SetIstemciHata', {
        Imza: imza,
        Mesaj: temizMesaj,
        Yigin: kirp(yigin, 4000),
        Url: url,
        Surum: kirp(surum(), 40),
      }, {
        headers: { 'api-version': '1.0', Authorization: 'bearer ' + depo.oku('token') },
      });
    } finally {
      gonderiyor = false;
    }
    if (p && typeof p.catch === 'function') p.catch(() => { /* sessiz: kendi hatası raporlanmaz */ });
  } catch (e) {
    gonderiyor = false;
    /* sessiz */
  }
}

let kuruldu = false;
export function istemciHataDinleyicileriKur() {
  if (kuruldu || typeof window === 'undefined') return;
  kuruldu = true;
  window.addEventListener('error', (e) => {
    // Kaynak (img/script) yükleme hataları ErrorEvent değil — atlanır.
    if (!e || !(e instanceof ErrorEvent)) return;
    // Deploy sonrası açık kalan eski sekme: silinmiş chunk yerine index.html geldi → rapor yok,
    // "yeni sürüm" uyarısı (YS1 ile aynı akış).
    if (eskiPaketHatasiMi(e)) { yeniSurumUyarisiAc(); return; }
    istemciHataBildir(e.error || null, e.message);
  });
  window.addEventListener('unhandledrejection', (e) => {
    istemciHataBildir(e && e.reason, 'Yakalanmamış Promise reddi');
  });
}
